import { createAction } from '@reduxjs/toolkit';
import { SmoMoonType } from '../../../../Models/Smo/SmoMoonType';

const setDebugMode = createAction<boolean>('SET_DEBUG_MODE');
const setIsImageProcessingPaused = createAction<boolean>('SET_IS_IMAGE_PROCESSING_PAUSED');
const updateFilterBrightness = createAction<{ brightness: number; moonType: SmoMoonType }>(
  'DEBUG_UPDATE_FILTER_BRIGHTNESS'
);
const processSingleMoonImage = createAction<HTMLImageElement>('PROCESS_SINGLE_MOON_IMAGE');
const processMultiMoonImage = createAction<HTMLImageElement>('PROCESS_MULTI_MOON_IMAGE');
const addSingleMoonCroppedTitle = createAction<string>('ADD_SINGLE_MOON_CROPPED_TITLE');
const addSingleMoonCroppedFilteredTitle = createAction<string>('ADD_SINGLE_MOON_CROPPED_FILTERED_TITLE');
const addSingleMoonCroppedName = createAction<string>('ADD_SINGLE_MOON_CROPPED_NAME');
const addSingleMoonCroppedFilteredName = createAction<string>('ADD_SINGLE_MOON_CROPPED_FILTERED_NAME');
const addMultiMoonCroppedName = createAction<string>('ADD_MULTI_MOON_CROPPED_NAME');
const addMultiMoonCroppedFilteredName = createAction<string>('ADD_MULTI_MOON_CROPPED_FILTERED_NAME');

export default {
  setDebugMode,
  setIsImageProcessingPaused,
  updateFilterBrightness,
  processSingleMoonImage,
  processMultiMoonImage,
  addSingleMoonCroppedTitle,
  addSingleMoonCroppedFilteredTitle,
  addSingleMoonCroppedName,
  addSingleMoonCroppedFilteredName,
  addMultiMoonCroppedName,
  addMultiMoonCroppedFilteredName
};
